
<template>
    
        <mars-view class="law-title-container"><mars-view class="title" :class="'title-' + fontSizeSetting">{{ title }}</mars-view><mars-view v-if="issueTime || implementTime" class="info-box" :class="'info-box-' + fontSizeSetting"><mars-view class="effective"><mars-view class="desc">{{ validStatus }}</mars-view></mars-view><mars-view v-if="issueTime" class="publish-time desc">发布：{{ issueTime }}</mars-view><mars-view v-if="implementTime" class="execute-time desc">实施：{{ implementTime }}</mars-view></mars-view></mars-view>
    
</template>

<script>
export default {
  props: {
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 发布时间
    issueTime: {
      type: String,
      default: ''
    },
    // 生效时间
    implementTime: {
      type: String,
      default: ''
    },
    // 状态
    validStatus: {
      type: String,
      default: ''
    },
    fontSizeSetting: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style scoped>
.law-title-container {
  padding-top: 5.6vw;
}
.law-title-container .title {
  font-family: PingFang SC;
  font-size: 5.07vw;
  color: #1e1f24;
  letter-spacing: 0;
  line-height: 7.73vw;
  font-weight: 700;
}
.law-title-container .title-5 {
  font-size: 18px;
}
.law-title-container .info-box {
  padding-top: 0.97vw;
  display: flex;
  align-items: center;
}
.law-title-container .info-box .effective {
  flex-shrink: 0;
  height: 3.86vw;
  border: 0.24vw solid rgba(0, 85, 255, 0.4);
  border-radius: 0.97vw;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.law-title-container .info-box .effective .desc {
  font-family: PingFang SC;
  font-weight: 700;
  padding: 0 0.97vw;
  margin-top: 0.24vw;
  font-size: 2.66vw;
  color: #05f;
  line-height: 2.66vw;
}
.law-title-container .info-box .publish-time {
  margin-left: 1.93vw;
}
.law-title-container .info-box .desc {
  font-family: PingFang SC;
  font-size: 3.38vw;
  color: #848691;
  line-height: 1;
}
.law-title-container .info-box .execute-time {
  margin-left: 1.93vw;
}
.law-title-container .info-box-5 .effective .desc {
  font-size: 9px;
}
.law-title-container .info-box-5 .publish-time,
.law-title-container .info-box-5 .execute-time {
  font-size: 10px;
}

</style>
